import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_FAMILY_MEMBER_VARISANGYA_WALLETS,
  CREATE_FAMILY_MEMBER_VARISANGYA_WALLET,
  GET_FAMILY_MEMBER_VARISANGYA_WALLET_DETAIL,
  GET_FAMILY_MEMBER_VARISANGYA_WALLET_VIEW,
  DELETE_FAMILY__MEMBER_VARISANGYA_WALLET,
} from "./actionTypes"
import {
  getFamilyMemberVarisangyaWalletsSuccess,
  getFamilyMemberVarisangyaWalletsFail,
  createFamilyMemberVarisangyaWalletSuccess,
  createFamilyMemberVarisangyaWalletFail,
  getFamilyMemberVarisangyaWalletDetailSuccess,
  getFamilyMemberVarisangyaWalletDetailFail,
  getFamilyMemberVarisangyaWalletViewSuccess,
  getFamilyMemberVarisangyaWalletViewFail,
  deleteFamilyMemberVarisangyaWalletFail,
  deleteFamilyMemberVarisangyaWalletSuccess,
} from "./actions"

import { get, post, del } from "helpers/api_methods"
import { Notification } from "components/Common/Notification"

const getFamilyMemberVarisangyaWalletsAPi = ({ searchText, page, sort }) => {
  if (sort === "manual") {
    return get(
      `/api/v1/varisankya/family_member_varisankya_wallet_transaction/?search=${
        searchText && searchText
      }&page=${page ? page : 1}&is_manual=True`
    )
  } else {
    return get(
      `/api/v1/varisankya/family_member_varisankya_wallet_transaction/?search=${
        searchText && searchText
      }&page=${page ? page : 1}`
    )
  }
}
const createFamilyMemberVarisangyaWalletApi = ({
  familyMemberVarisangyaWallet,
}) => {
  return post(
    "/api/v1/varisankya/family_member_varisankya_wallet_transaction/",
    familyMemberVarisangyaWallet
  )
}
const getFamilyMemberVarisangyaWalletDetailAPi = ({
  familyMemberId,
  page,
  searchText,
  sort,
}) => {
  if (sort === "manual") {
    return get(
      `/api/v1/varisankya/family_member_varisankya_wallet_transaction/?family_member=${
        familyMemberId && familyMemberId
      }&search=${searchText && searchText}&page=${
        page ? page : 1
      }&is_manual=True`
    )
  } else {
    return get(
      `/api/v1/varisankya/family_member_varisankya_wallet_transaction/?family_member=${
        familyMemberId && familyMemberId
      }&search=${searchText && searchText}&page=${page ? page : 1}`
    )
  }
}

const getFamilyMemberVarisangyaWalletViewAPi =
  familyMemberVarisangyaWalletId => {
    return get(
      `/api/v1/varisankya/family_member_varisankya_wallet_transaction/${familyMemberVarisangyaWalletId}/`
    )
  }

const deleteFamilyMemberVarisangyaWalletApi = ({ transactionId }) => {
  return del(
    `/api/v1/varisankya/family_member_varisankya_wallet_transaction/${transactionId}/
      `
  )
}

function* fetchFamilyMemberVarisangyaWallets({ payload }) {
  try {
    const response = yield call(getFamilyMemberVarisangyaWalletsAPi, payload)
    if (response && !response?.error) {
      yield put(getFamilyMemberVarisangyaWalletsSuccess(response))
    } else {
      yield put(getFamilyMemberVarisangyaWalletsFail(response))
      errorNotification()
    }
  } catch (error) {
    yield put(getFamilyMemberVarisangyaWalletsFail(error))
  }
}

function* onCreateFamilyMemberVarisangyaWallet({ payload }) {
  try {
    const response = yield call(createFamilyMemberVarisangyaWalletApi, payload)
    if (response && !response?.error) {
      yield put(createFamilyMemberVarisangyaWalletSuccess(response))
      doneNotification("Created Successfully")
    } else {
      yield put(createFamilyMemberVarisangyaWalletFail(response))
      errorNotification()
    }
    // swal({
    //   title: "Zakats Submited",
    //   icon: "success",
    //   button: "ok",
    // })
  } catch (error) {
    // console.log("error: ", error)
    yield put(createFamilyMemberVarisangyaWalletFail(error))
    errorNotification()
  }
}

function* fetchFamilyMemberVarisangyaWalletDetail({ payload }) {
  try {
    const response = yield call(
      getFamilyMemberVarisangyaWalletDetailAPi,
      payload
    )
    if (response && !response?.error) {
      yield put(getFamilyMemberVarisangyaWalletDetailSuccess(response))
    } else {
      yield put(getFamilyMemberVarisangyaWalletDetailFail(response))
      errorNotification()
    }
  } catch (error) {
    yield put(getFamilyMemberVarisangyaWalletDetailFail(error))
  }
}

function* fetchFamilyMemberVarisangyaWalletView({
  familyMemberVarisangyaWalletId,
}) {
  try {
    const response = yield call(
      getFamilyMemberVarisangyaWalletViewAPi,
      familyMemberVarisangyaWalletId
    )
    if (response && !response?.error) {
      yield put(getFamilyMemberVarisangyaWalletViewSuccess(response))
    } else {
      yield put(getFamilyMemberVarisangyaWalletViewFail(response))
      errorNotification()
    }
  } catch (error) {
    yield put(getFamilyMemberVarisangyaWalletViewFail(error))
  }
}

function* deleteFamilyMemberVarisangyaWallet({ payload }) {
  try {
    const response = yield call(deleteFamilyMemberVarisangyaWalletApi, payload)
    if (response && !response?.error) {
      doneNotification("Transaction Removed Successfully")
      const familyMemberResponse = yield call(
        getFamilyMemberVarisangyaWalletDetailAPi,
        {
          familyMemberId: response?.family_member,
          page: 1,
          searchText: "",
          sort: "",
        }
      )
      if (familyMemberResponse) {
        yield put(
          getFamilyMemberVarisangyaWalletDetailSuccess(familyMemberResponse)
        )
      }
      // yield call(getFamilyMemberVarisangyaWalletViewAPi, response?.family)
    } else {
      yield put(deleteFamilyMemberVarisangyaWalletFail(response))
      errorNotification()
    }
  } catch (error) {
    yield put(deleteFamilyMemberVarisangyaWalletFail(error))
  }
}

function errorNotification() {
  Notification({
    type: "error",
    message: "Something Went Wrong",
    title: "Try Again",
  })
}
function doneNotification(msg) {
  Notification({
    type: "success",
    message: msg ? msg : "Done",
    title: "",
  })
}

function* FamilyMemberVarisangyaWalletsSaga() {
  yield takeEvery(
    GET_FAMILY_MEMBER_VARISANGYA_WALLETS,
    fetchFamilyMemberVarisangyaWallets
  )
  yield takeEvery(
    CREATE_FAMILY_MEMBER_VARISANGYA_WALLET,
    onCreateFamilyMemberVarisangyaWallet
  )
  yield takeEvery(
    GET_FAMILY_MEMBER_VARISANGYA_WALLET_DETAIL,
    fetchFamilyMemberVarisangyaWalletDetail
  )
  yield takeEvery(
    GET_FAMILY_MEMBER_VARISANGYA_WALLET_VIEW,
    fetchFamilyMemberVarisangyaWalletView
  )
  yield takeEvery(
    DELETE_FAMILY__MEMBER_VARISANGYA_WALLET,
    deleteFamilyMemberVarisangyaWallet
  )
}

export default FamilyMemberVarisangyaWalletsSaga
